/**
 * メンバーの行動通知の文言。
 * 定義書「メッセージ一覧」の I005 / I006 に対応する。
 */

import type { ActivityPayload } from "../realtime/types.js";

/**
 * 通知として表示する文言を組み立てる。
 * 表示しない種類の場合は null を返す。
 *
 * 誤答は通知しない。定義書に対応するメッセージがなく、
 * 得点の変動はヘッダの表示で分かるため、通知を増やすと画面が騒がしくなる。
 */
export function activityMessage(activity: ActivityPayload): string | null {
  switch (activity.kind) {
    case "correct":
      return `${activity.participantName}さんが${activity.questionLabel}に正解しました（+${activity.deltaPoints}点）`;
    case "hint":
      return `${activity.participantName}さんが${activity.questionLabel}のヒントを使用しました（${activity.deltaPoints}点）`;
    case "wrong":
      return null;
  }
}
